module.exports = __webpack_public_path__ + "static/eye-c66225172f258d3aebd62bb365b7d426.jpg";